export const NotificationQueryKeys = {
  all: ['notifications'],
  unread: ['unread_notifications'],
  pagination: (page: number) => [...NotificationQueryKeys.all, 'pagination', page],
  infinite: () => [...NotificationQueryKeys.all, 'infinite'],
};
